import {FormInstance} from 'antd/es/form';
import React, {useEffect, useState} from 'react';

import {generateEditableMetadata} from 'components/editable-table/lib';
import {EditableFormTableContext} from 'components/editable-table/model/editable-form-table.context';
import {TEditableColumn, IValidationController} from 'components/editable-table/model/types';
import {EditableTable} from 'components/editable-table/ui';
import {ITableProps} from 'components/table/table';
import {TableActions} from 'components/table/table-actions/table-actions';
import {IFieldMeta} from 'entities/metadata';
import {TEntity} from 'modules/data';

interface IEditableTableContainerProps extends ITableProps{
}

export const EditableTableContainer = ({
    entityName, tableData, metadata, onChange, url, loading, rowSelection,
}: IEditableTableContainerProps) => {
    const [initData, setInitData] = useState<TEntity[]>([]);
    const [form, setForm] = useState<FormInstance>();
    const [columnsMeta, setColumnsMeta] = useState<TEditableColumn[] | undefined>();
    const [validation, setValidation] = useState<IValidationController>();

    const fields = metadata?.fields;

    useEffect(() => {
        if (fields) {
            const arr = (fields as IFieldMeta[])?.map(item => generateEditableMetadata(item));
            setColumnsMeta(arr);
        }
    }, [fields]);

    const handleEdit = (tableRow: TEntity) => {
        const index = initData?.findIndex(element => element.id === tableRow?.id);
        if (index !== -1) {
            initData.splice(index, 1);
            setInitData([...initData, tableRow]);
            return;
        }
        setInitData([...initData, tableRow]);
    };

    return (
        <EditableFormTableContext.Provider
            value={{
                form,
                setForm,
                initData,
                validation,
                setValidation,
            }}
        >
            <TableActions
                url={url}
                entityName={entityName}
                metadata={metadata}
            />
            {columnsMeta && (
                <EditableTable
                    entityName={entityName}
                    handleSave={handleEdit}
                    columns={columnsMeta}
                    tableData={tableData}
                    url={url}
                    metadata={metadata}
                    rowSelection={rowSelection}
                    onChangeTable={onChange}
                    loading={loading}
                    isSelectable={metadata?.isSelectable}
                    linkField={metadata?.linkField}
                    dependentLinkField={metadata?.dependentLinkField}
                />
            )}
        </EditableFormTableContext.Provider>
    );
};
